import {observable, action, computed} from "mobx";
import { StoreClass } from "../stores/Store";
import FabricCollectionModel from "./FabricCollectionModel";



export default class FabricModel {
    store: StoreClass;
    @observable id = null;
    @observable name = null;
    
    @observable price = 0;
    @observable data:FabricDataType = {};
    /**
     *
     * @param {FabricDataType} props
     */
    constructor({ store, ...props }) {
        if (!store) {
            throw Error(`store is undefined`);
        }
        this.store = store;
        this.fromJSON(props);
        // this.category = props.category;
    }

    @computed get colorGroup():{id: number, name: string} {
        var groups = this.getAttrbute('color_groups');
        if(groups?.length > 0){
            return groups.at(0);
        }
        return {id: 0, name: 'Undefined'};
    }
    @computed get colorGroups():Array<{id: number, name: string}> {
        var groups = this.getAttrbute('color_groups');
        if(groups?.length > 0){
            return groups;
        }
        return [{id: 0, name: 'Undefined'}];
    }
    @computed get colorGroupId():number {
        var groups = this.getAttrbute('color_groups');
        if(groups?.length > 0){
            return groups.at(0).id;
        }
        return null;
    }
    @computed get colorGroupIds():number {
        var groups = this.getAttrbute('color_groups');
        if(groups?.length > 0){
            return groups.map(g => g.id);
        }
        return [];
    }
    @computed get color(){
        return this.getAttrbute('color');
    }

    @computed get imageUrl() {
        var images = this.getAttrbute('image');
        if(images?.length > 0){
            return images.at(0);
        }
        return null;
    }
    @computed get thumbUrl() {
        return this.imageUrl;
    }

    @computed get category():FabricCollectionModel {
        const found = this.store.fabric_collection.find((category) => category.fabricsIds.includes(this.id));
        if(found){
            return found;
        }
        return null;
    }

    @computed get fabricCategoryName(){
        if(this.category){
            return this.category.name;
        }
        return null;
    }
    @computed get fabricCategoryId(){
        if(this.category){
            return this.category.id;
        }
        return null;
    }

    
    

    fromJSON(props) {
        this.data = props;
        this.name = props.name;
        this.id = parseInt(props.id);
        try {
            this.optionId = this.data.productOptions[0].optionId;
            this.productId = parseInt(this.data.productOptions[0].valueId);
            this.valueId = parseInt(this.data.productOptions[0].valueId);
        } catch (err) {
            throw Error(`Infalid productOptions for fabric ${this.name}`);
        }

        if(isNaN(this.productId)){
            throw Error('productId is not a number');
        }

        if(isNaN(this.valueId)){
            throw Error('valueId is not a number');
        }

        
        if(isNaN(this.id)){
            console.error(this.data);
            throw Error('id is not a number ' + this.id);
        }
        this.price = parseFloat(this.data.price);
        // var p = this.getExtraData('price');
        // if(p){
            // this.price = parseFloat(p);
        // }
    }

    getAttrbute(name){
        if(this.data.attributes && this.data.attributes[name] !== undefined){
            return this.data.attributes[name];
        }
        return null;
    }


    getExtraData(name){
        if(this.data.ch_extra_data?.items.length > 0 && this.data.extraData[name] !== undefined){
            return this.data.ch_extra_data.items[0][name];
        }
        return null;
    }

    toString() {
        return `FabricModel: ${this.id} - ${this.name}`;
    }

    toJson() {
        return this.data;
    }
    

    static create(data) {
        return new FabricModel(data);
    }
}



export class FabricDataType{
    id = 0;
    name = 'Undefined';
    image = null;
    texture = {
        name: 'Undefined',
        image: null
    };
    price = 0;
    productOptions: Array<{optionId: number, valueId: number}> = [];
    attributes:Array<any> = [];
    
}